import styled, { css } from 'styled-components'
import { EDevice } from '../../../store'

export const Container = styled.div``

export const Body = styled.div<{ device: EDevice }>`
    display: flex;
    padding: 16px;
    background-color: #f7f8fa;
    @media screen and (max-width: 768px) {
        padding: 0;
    }
`

export const LeftContainer = styled.div<{ device: EDevice; isShowMenu: boolean }>`
    transition: 0.5s;
    ${({ device, isShowMenu }) => {
        switch (device) {
            case EDevice.DESKTOP:
                return css`
                    flex: 0 0 ${!isShowMenu ? '76px' : '338px'};
                    max-width: ${!isShowMenu ? '76px' : '338px'};
                    padding-right: 16px;
                `
            case EDevice.LAPTOP:
                return css`
                    flex: 0 0 ${!isShowMenu ? '76px' : '338px'};
                    max-width: ${!isShowMenu ? '76px' : '338px'};
                    padding-right: 16px;
                `
            case EDevice.TABLET:
                return css`
                    width: ${isShowMenu ? '295px' : '76px'};
                    padding-right: 16px;
                `
            case EDevice.MOBILE:
                return css`
                    width: 0;
                    height: 0;
                `
        }
    }}
`

type TChildren = {
    isHaveRightContainer: boolean
    isShowMenu: boolean
    device: EDevice
}
export const ChildrenContainer = styled.div<TChildren>`
    transition: 0.5s;
    ${({ isShowMenu, isHaveRightContainer, device }) => {
        if (device === EDevice.MOBILE) {
            return css`
                flex: 100vw !important;
                overflow: hidden;
            `
        }
        if (device === EDevice.TABLET && isHaveRightContainer) {
            return css`
                flex: 0 0 ${!isShowMenu ? 'calc(100% - 76px)' : 'calc(100% - 300px)'};
                max-width: ${!isShowMenu ? 'calc(100% - 76px)' : 'calc(100% - 300px)'};
            `
        }
        if (device === EDevice.TABLET && !isHaveRightContainer) {
            return css`
                flex: 0 0 ${!isShowMenu ? 'calc(100% - 76px)' : 'calc(100% - 295px)'};
                max-width: ${!isShowMenu ? 'calc(100% - 76px)' : 'calc(100% - 295px)'};
            `
        }
        if (isHaveRightContainer) {
            return css`
                flex: 0 0 ${!isShowMenu ? 'calc((100% - 76px - 338px))' : 'calc(100% - (338px * 2))'};
                max-width: ${!isShowMenu ? 'calc((100% - 76px - 338px))' : 'calc(100% - (338px * 2))'};
            `
        }
        if (!isHaveRightContainer) {
            return css`
                flex: 0 0 ${!isShowMenu ? 'calc(100% - 76px)' : 'calc(100% - 338px)'};
                max-width: ${!isShowMenu ? 'calc(100% - 76px)' : 'calc(100% - 338px)'};
            `
        }
    }}
`

export const RightContainer = styled.div<{ device: EDevice; isShowMenu: boolean }>`
    transition: 0.5s;
    ${({ device, isShowMenu }) => {
        if (device === EDevice.DESKTOP) {
            return css`
                flex: 0 0 338px;
                max-width: 338px;
                padding-left: 16px;
            `
        } else {
            return css`
                flex: 1;
            `
        }
    }}
`
